import { defineComponent as _defineComponent } from 'vue'
import SearchInput from '@/components/molecules/SearchInput.vue';
import BCXIcon from '@/components/molecules/BCXIcon.vue';
import BCXMessengerFilters from '@/components/messenger/Tools/BCXMessengerFilters.vue';
import useMessengerState from '@/state/messenger/messengerState';
import { MessengerMaxChars } from '@/models/Messenger';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerTools',
  setup(__props) {

const {
  searchTerm,
  showSortPanel,
  isFlat,
} = useMessengerState();


return { __sfc: true,searchTerm, showSortPanel, isFlat, SearchInput, BCXIcon, BCXMessengerFilters, MessengerMaxChars }
}

})